export const listNameRegExp = /^.{4,24}$/;
export const listEmptyListNameMessage = 'Please enter the list name';
export const listDuplicateListMessage = ['Name is already in use', 'List name already in use.'];
export const signinEmailRegExp = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[a-zA-Z0-9]{1,})*(\.[a-zA-Z]{2,})$/;
export const genericErrorMessage =
    'There was an error while processing your request. Please try again.';
export const listsRedesignCookieFlagName = 'DP_OOS_LISTING_REDESIGN';
export const listsRedesignHeaderFlagName = 'X-OOS-LISTING-REDESIGN';
